import React from 'react';
import { graphql } from 'gatsby';
import PartialCTA from './partials/cta';
import { cn } from '../../utils/helpers';

const CTA = ({ block }) => {
  if (!block) {
    return null;
  }

  let positionClass =
    block.cta_position === 'Center' ? 'pos-center' : 'pos-left';
  let cssClassName = block.css_class_name ? block.css_class_name : '';

  return (
    <section
      className={cn(`block__cta block ${cssClassName} ${positionClass}`)}
    >
      <div className='container'>
        <PartialCTA data={block} />
      </div>
    </section>
  );
};

export default CTA;

export const ctaFieldFragment = graphql`
  fragment CtaFieldFragment on CtaField {
    cta_position
    cta_subtext
    cta_text
    cta_type
    cta_url
    font_size
    override_behaviour
    style
    subtext_right
    second_cta {
      text
      url
      color
    }
    video_cta {
      text
      html
    }
    mobile {
      text
    }
  }
`;
